import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Modal, Form, Button, Popup, Dropdown, Icon, Input, Image, Item, Menu, Grid, Table, Label, Dimmer, Pagination, Message, TextArea, Checkbox } from 'semantic-ui-react';
import { showLoading, hideLoading, setActivePage, getVouchers, openVoucherModal, createVoucher, deleteVoucher, getProductMaterials } from '../actions';

const popupStyle = {
    opacity: 0.7
}

class Vouchers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // using now
            voucher_list: [],
            status: 'ok',
            new_voucher_code: "",
            new_voucher_description: "",
            new_voucher_start_date: null,
            new_voucher_has_expiry: false,
            new_voucher_expiry_date: null,
            new_voucher_value_type: 'cash',
            new_voucher_value_cash: null,
            new_voucher_value_percentage: null,
            new_voucher_min_purchase: 0.0,
            new_voucher_user_limit: 0,
            new_voucher_usage_limit: 1,
            new_voucher_error_message: null,
            new_voucher_product_selection: "all",
            new_voucher_product_material: "none",
            new_voucher_offer_qty: 0,
            selectedProductMaterialsList: null,
            column: null,
            data: [],
            length: 0,
            direction: null,
            page: 0,
            rowsPerPage: 15,
            addStaffModal: false,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        this.props.showLoading('Retrieving vouchers . . .');
        this.props.getVouchers({});
        this.props.getProductMaterials();

    }

    componentDidMount() {
        this.props.setActivePage('vouchers');
    }

    componentWillReceiveProps(nextProps) {
        console.log('Order componentWillReceiveProps');
        if (this.props.voucher !== nextProps.voucher) {
            if (nextProps.voucher.status === 'ok') {
                console.log('New voucher list: ' + JSON.stringify(nextProps.voucher.voucher_list));
                this.setState({ voucher_list: _.chunk(nextProps.voucher.voucher_list, this.state.rowsPerPage), length: nextProps.voucher.voucher_list.length, direction: nextProps.voucher.sortDirection, status: nextProps.voucher.status, page: 0 });
                this.props.hideLoading();
            } else {
                this.setState({ status: nextProps.voucher.status });
            }

            if ((this.props.voucher.openVoucherModal !== nextProps.voucher.openVoucherModal) && (nextProps.voucher.openVoucherModal)) {
                this.clearVoucherFrom();
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.new_voucher_product_selection !== prevState.new_voucher_product_selection) {
            const { new_voucher_product_selection } = this.state;
            if (new_voucher_product_selection == "all") {
                this.setState({ selectedProductMaterialsList: null, new_voucher_product_material: "none" });
            } else {
                this.props.getProductMaterials();
                const productMaterialsList = this.props.product.materials.find((item) => item.name === new_voucher_product_selection);
                if (new_voucher_product_selection.includes('Booklet')) {
                    let booklMaterialsList = this.props.product.materials.find((item) => item.name.includes('Booklet'));
                    let bookletMaterials = booklMaterialsList.cover_material.values.concat(booklMaterialsList.inner_material.values);
                    console.log(bookletMaterials);
                    let firstBookletMaterial = bookletMaterials.find((material, index) => { if (index === 0) return material; });
                    this.setState({ selectedProductMaterialsList: bookletMaterials, new_voucher_product_material: firstBookletMaterial });
                } else if (new_voucher_product_selection === 'Racing Horse Calendar With Header') {
                    let calendarHeaderMaterials = productMaterialsList.header_material.values.concat(productMaterialsList.inner_material.values);
                    console.log(calendarHeaderMaterials);
                    let firstcalendarHeaderMaterials = calendarHeaderMaterials.find((material, index) => { if (index === 0) return material; });
                    this.setState({ selectedProductMaterialsList: calendarHeaderMaterials, new_voucher_product_material: firstcalendarHeaderMaterials });
                } else {
                    let firstSelection = productMaterialsList.material.values.find((material, index) => { if (index === 0) return material; });
                    this.setState({ selectedProductMaterialsList: productMaterialsList.material.values, new_voucher_product_material: firstSelection });
                }

            }
        }
        if (this.props.product.pricing !== prevProps.product.pricing) {
            const { new_voucher_product_selection } = this.state;
            if (new_voucher_product_selection.includes('Sticker Label')) {
                const stickerMaterialsList = this.props.product.pricing.material.prices.map((el) => el.paper_type);
                console.log(stickerMaterialsList);
                let firstStickerSelection = stickerMaterialsList.material.values.find((material, index) => { if (index === 0) return material; });
                this.setState({ selectedProductMaterialsList: stickerMaterialsList, new_voucher_product_material: firstStickerSelection });
            } else {
                this.setState({ selectedProductMaterialsList: null, new_voucher_product_material: "none" });
            }
        }
    }

    handleSort = clickedColumn => () => {
        const { column, data, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            data: data.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    handleInputChange(e, data) {
        console.log(e);
        console.log(data);
        this.setState({
            [data.id]: data.value
        });
    }

    clearVoucherFrom() {
        this.setState({
            new_voucher_code: "",
            new_voucher_description: "",
            new_voucher_start_date: null,
            new_voucher_has_expiry: false,
            new_voucher_expiry_date: null,
            new_voucher_value_type: 'cash',
            new_voucher_value_cash: null,
            new_voucher_value_percentage: null,
            new_voucher_min_purchase: 0.0,
            new_voucher_usage_limit: 1,
            new_voucher_user_limit: 0,
            new_voucher_error_message: null,
            new_voucher_product_selection: "all",
            new_voucher_product_material: "none",
            new_voucher_offer_qty: 0,
        })
    }

    closeCreateModal() {
        this.props.openVoucherModal(false);
    }

    createNewVoucher() {
        const { new_voucher_code, new_voucher_description, new_voucher_start_date, new_voucher_has_expiry, new_voucher_expiry_date, new_voucher_value_type,
            new_voucher_value_cash, new_voucher_value_percentage, new_voucher_min_purchase, new_voucher_user_limit, new_voucher_usage_limit, new_voucher_product_selection, new_voucher_product_material, new_voucher_offer_qty } = this.state;
        let start_date = (new_voucher_start_date) ? new Date(new_voucher_start_date) : null;
        let expiry_date = (new_voucher_expiry_date) ? new Date(new_voucher_expiry_date) : null;

        if (!new_voucher_code) {
            this.setState({ new_voucher_error_message: 'Please Fill Voucher Code', new_voucher_code_error: true });
        } else if (!new_voucher_start_date) {
            this.setState({ new_voucher_error_message: 'Start Date is needed', new_voucher_start_date_error: true })
        } else if (new_voucher_has_expiry && !new_voucher_expiry_date) {
            this.setState({ new_voucher_error_message: 'Expiry date selected, please input expiry date', new_voucher_expiry_date_error: true });
        } else if (new_voucher_value_type === 'cash' && !new_voucher_value_cash) {
            this.setState({ new_voucher_error_message: 'Cash discount selected, please input cash value', new_voucher_value_cash_error: true });
        } else if (new_voucher_value_type === 'percentage' && !new_voucher_value_percentage) {
            this.setState({ new_voucher_error_message: 'Discount percentage selected, please input discount percentage', new_voucher_value_percentage_error: true });
        } else if (new_voucher_value_type === 'percentage' && (new_voucher_value_percentage < 0 || new_voucher_value_percentage > 100)) {
            this.setState({ new_voucher_error_message: 'Discount percentage has to be within 0 - 100%', new_voucher_value_percentage_error: true });
        } else if (new_voucher_value_type === 'cash' && (new_voucher_value_cash <= 0)) {
            this.setState({ new_voucher_error_message: 'Cash amount has to be more than 0', new_voucher_value_cash_error: true });
        } else if (new_voucher_expiry_date && ((expiry_date.getTime() - start_date.getTime()) < 0)) {
            this.setState({ new_voucher_error_message: 'Voucher expiry has a minimum of 1 day' });
        } else if (new_voucher_usage_limit < 0) {
            this.setState({ new_voucher_error_message: 'Usage limit cannot be less than 0', new_voucher_usage_limit_error: true });
        } else if (new_voucher_user_limit < 0) {
            this.setState({ new_voucher_error_message: 'User limit cannot be less than 0', new_voucher_user_limit_error: true });
        } else if (new_voucher_user_limit > new_voucher_usage_limit) {
            this.setState({ new_voucher_error_message: 'User limit cannot exceed maximum usage limit', new_voucher_usage_limit_error: true, new_voucher_user_limit_error: true });
        } else if (new_voucher_min_purchase < 0) {
            this.setState({ new_voucher_error_message: 'Minimum purchase amount cannot be less than 0', new_voucher_min_purchase_error: true });
        } else if (new_voucher_offer_qty < 0) {
            this.setState({ new_voucher_error_message: 'Offer quantity cannot be less than 0', new_voucher_offer_qty_error: true });
        } else {
            let newVoucher = {
                _id: new_voucher_code,
                description: new_voucher_description,
                start_date: start_date,
                expiry_date: expiry_date,
                voucher_type: new_voucher_value_type,
                discount_value: new_voucher_value_cash,
                discount_percentage: new_voucher_value_percentage,
                min_purchase: parseFloat(new_voucher_min_purchase),
                user_limit: parseInt(new_voucher_user_limit),
                max_usage: new_voucher_usage_limit,
                promo_product: new_voucher_product_selection,
                promo_product_material: new_voucher_product_material,
                offer_qty: parseInt(new_voucher_offer_qty),
                claimants: []
            };
            this.setState({ new_voucher_error_message: null })
            console.log(newVoucher);
            this.props.createVoucher(newVoucher);
            this.clearVoucherFrom();
        }
    }

    deleteVoucher(voucher_id) {
        var isConfirmed = window.confirm(`Delete this voucher (${voucher_id})?`);
        if (isConfirmed === false) {
            return;
        }

        this.props.deleteVoucher(voucher_id);
    }

    handleCreateVoucherModalInput(event) {
        var elementId = event.target.id;
        var elementValue = event.target.value;

        var newState = {};

        if (elementId === 'new_voucher_has_expiry') {
            elementValue = event.target.checked;
            if (elementValue === false) {
                newState['new_voucher_expiry_date'] = null;
            }
        } else if (elementId === 'new_voucher_value_type') {
            if (elementValue === 'cash') {
                newState['new_voucher_value_percentage'] = null;
            } else if (elementValue === 'percentage') {
                newState['new_voucher_value_cash'] = null;
            }
        }
        // When Product is ALL, Minimum Purchase Quantity Will be disable and reset to 0
        // When Product selected specifc prouct, Minimum Purchase
        if (elementId === 'new_voucher_product_selection') {
            if (elementValue === 'all') {
                this.setState({ new_voucher_offer_qty: 0 })
            } else {
                this.setState({ new_voucher_min_purchase: 0 })
            }
        }
        // Show Specific Error Field
        if (elementId === "new_voucher_value_cash" && elementValue > 0) {
            this.setState({ new_voucher_value_percentage_error: false, new_voucher_value_cash_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_value_percentage" && ((elementValue > 0) && (elementValue < 100))) {
            this.setState({ new_voucher_value_cash_error: false, new_voucher_value_percentage_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_code" && elementValue) {
            this.setState({ new_voucher_code_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_start_date" && elementValue) {
            this.setState({ new_voucher_start_date_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_expiry_date" && elementValue) {
            this.setState({ new_voucher_expiry_date_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_usage_limit" && elementValue < 0) {
            this.setState({ new_voucher_usage_limit_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_user_limit" && elementValue < 0) {
            this.setState({ new_voucher_user_limit_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_min_purchase" && elementValue < 0) {
            this.setState({ new_voucher_min_purchase_error: false, new_voucher_error_message: null })
        } else if (elementId === "new_voucher_offer_qty" && elementValue < 0) {
            this.setState({ new_voucher_offer_qty_error: false, new_voucher_error_message: null })
        } else if (this.state.new_voucher_user_limit > this.state.new_voucher_usage_limit) {
            this.setState({ new_voucher_usage_limit_error: false, new_voucher_user_limit_error: false, new_voucher_error_message: null })
        }

        newState[elementId] = elementValue;
        this.setState(newState);
    }

    handleMessageDismiss() {
        this.setState({ status: 'ok' });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving vouchers . . .');
        this.props.getVouchers({});
        console.log("Refresh List");
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.description));

        let list = _.filter(this.props.voucher.voucher_list, isMatch);
        this.setState({ voucher_list: _.chunk(list, this.state.rowsPerPage), length: list.length });
    }

    render() {
        const { voucher_list, column, direction, selectedPeriod, selectedYear, selectedMonth, status, page, rowsPerPage, length, searchValue } = this.state;
        const { voucherModalOpen } = this.props.voucher;
        let now = new Date();

        return (
            <Fragment>
                <Modal open={voucherModalOpen}>
                    <Modal.Header>
                        Create New Voucher
                    </Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field required>
                                <label>Voucher Code</label>
                                <Form.Input id="new_voucher_code"
                                    value={this.state.new_voucher_code}
                                    onChange={this.handleCreateVoucherModalInput.bind(this)}
                                    placeholder="Voucher Code"
                                    error={this.state.new_voucher_code_error}
                                    required />
                            </Form.Field>
                            <Form.Field
                                id='new_voucher_description'
                                control={TextArea}
                                label='Description'
                                placeholder='Description'
                                value={this.state.new_voucher_description}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                            />
                            <Form.Field id="new_voucher_product_selection"
                                label='Product Selection'
                                control='select'
                                value={this.state.new_voucher_product_selection}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                            >
                                <option value='all'>All</option>
                                {this.props.product.materials ? this.props.product.materials.map((item) => { return (item.name == "Digital Booklet" ? <Fragment><option value={"1 Colour Digital Booklet"}>  1 Colour Digital Booklet </option> <option value={"4 Colour Digital Booklet"}>  4 Colour Digital Booklet </option></Fragment> : <option value={item.name}> {item.name} </option>) }) : null}
                            </Form.Field>
                            <Form.Field id="new_voucher_product_material"
                                label='Product Material'
                                control='select'
                                value={this.state.new_voucher_product_material}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                                disabled={this.state.new_voucher_product_selection === "all"}
                            >
                                {this.state.selectedProductMaterialsList ? this.state.selectedProductMaterialsList.map((el) => { return <option value={el}> {el} </option>; }) : <option value='none'> None </option>}

                            </Form.Field>
                            <Form.Field required>
                                <Popup
                                    trigger={<Form.Input id="new_voucher_offer_qty"
                                        label='Minimum Product Quantity'
                                        placeholder="Minimum purchase to use the promo code"
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.new_voucher_offer_qty}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_offer_qty_error}
                                        disabled={this.state.new_voucher_product_selection === "all"}
                                    />}
                                    content='How many quantity that you want to offer'
                                    style={popupStyle}
                                    position='bottom left'
                                    inverted
                                />
                            </Form.Field>
                            <Form.Input fluid
                                id="new_voucher_start_date"
                                label='Start Date'
                                placeholder='Start Date'
                                type="date"
                                value={this.state.new_voucher_start_date}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                                error={this.state.new_voucher_start_date_error}
                                required />
                            <Form.Field id="new_voucher_has_expiry"
                                control={Checkbox}
                                label={{ children: 'The voucher will expire' }}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                                checked={this.state.new_voucher_has_expiry} />
                            {this.state.new_voucher_has_expiry === true && (
                                <Form.Input id="new_voucher_expiry_date"
                                    fluid
                                    label='Expiry Date'
                                    placeholder='Expiry Date'
                                    type="date"
                                    min={this.state.new_voucher_start_date}
                                    value={this.state.new_voucher_expiry_date}
                                    onChange={this.handleCreateVoucherModalInput.bind(this)}
                                    error={this.state.new_voucher_expiry_date_error}
                                    required />
                            )}
                            <Form.Field id="new_voucher_value_type"
                                label='Type'
                                control='select'
                                value={this.state.new_voucher_value_type}
                                onChange={this.handleCreateVoucherModalInput.bind(this)}
                            >
                                <option value='cash'>Cash value</option>
                                <option value='percentage'>Discount by percentage</option>
                            </Form.Field>
                            {this.state.new_voucher_value_type === 'percentage' && (
                                <Form.Field required>
                                    <label>Discount %</label>
                                    <Form.Input id="new_voucher_value_percentage"
                                        placeholder="Discount percentage. Eg: 5, 10, 15"
                                        type="number"
                                        min="0"
                                        value={this.state.new_voucher_value_percentage}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_value_percentage_error}
                                    />
                                </Form.Field>
                            )}
                            {this.state.new_voucher_value_type === 'cash' && (
                                <Form.Field required>
                                    <label>Cash Value</label>
                                    <Form.Input id="new_voucher_value_cash"
                                        placeholder="Cash value. Eg: 1.50, 5.00, 10"
                                        type="number"
                                        min="0"
                                        value={this.state.new_voucher_value_cash}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_value_cash_error}
                                    />
                                </Form.Field>
                            )}
                            <Form.Field required>
                                <Popup
                                    trigger={<Form.Input id="new_voucher_min_purchase"
                                        label="Minimum Purchase (RM)"
                                        placeholder="Minimum purchase to use the promo code"
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.new_voucher_min_purchase}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_min_purchase_error}
                                        disabled={this.state.new_voucher_product_selection !== "all"}
                                    />}
                                    content='Minimum purchase to use the promo code'
                                    style={popupStyle}
                                    position='bottom left'
                                    inverted
                                />
                            </Form.Field>
                            <Form.Field required>
                                <label>User Limit</label>
                                <Popup
                                    trigger={<Form.Input id="new_voucher_user_limit"
                                        placeholder="How many time a user can use this voucher, enter 0 for no limit"
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.new_voucher_user_limit}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_user_limit_error}
                                    />}
                                    content='How many time a user can use this voucher, enter 0 for no limit'
                                    style={popupStyle}
                                    position='bottom left'
                                    inverted
                                />
                            </Form.Field>
                            <Form.Field required>
                                <label>Max Usage Limit</label>
                                <Popup
                                    trigger={<Form.Input id="new_voucher_usage_limit"
                                        placeholder="How many time this voucher can be used"
                                        type="number"
                                        min="1"
                                        step="1"
                                        value={this.state.new_voucher_usage_limit}
                                        onChange={this.handleCreateVoucherModalInput.bind(this)}
                                        error={this.state.new_voucher_usage_limit_error}
                                    />}
                                    content='How many voucher that can be use'
                                    style={popupStyle}
                                    position='bottom left'
                                    inverted
                                />
                            </Form.Field>
                        </Form>
                        {this.state.new_voucher_error_message !== null && (
                            <Message
                                error
                                header='Error'
                                content={this.state.new_voucher_error_message}
                                style={{ display: 'block' }}
                            />
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeCreateModal.bind(this)}>Close</Button>
                        <Button color='primary' onClick={this.createNewVoucher.bind(this)}>Create</Button>
                    </Modal.Actions>
                </Modal>
                {/* <Button onClick={this.openCreateModal.bind(this)}>Create New Voucher</Button> */}
                {(status !== 'ok') &&
                    <Message
                        negative
                        header='ERROR'
                        content={status}
                        onDismiss={this.handleMessageDismiss.bind(this)}
                    />
                }
                <Grid>
                    <Grid.Column floated='left' width={14}>
                        <Input icon='search' placeholder='Search...' value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh' /></Button>
                    </Grid.Column>
                </Grid>

                <Table sortable striped selectable collapsing>
                    <Table.Header>
                        <Table.Row>
                            {/* Show if the code is currently good or expired */}
                            <Table.HeaderCell style={{ textAlign: 'center' }}>
                                <Icon name='info circle' size='large' />
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === '_id' ? direction : null} onClick={this.handleSort('_id')}>
                                Voucher Code
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Description
                            </Table.HeaderCell>
                            {/* <Table.HeaderCell>
                                    Min Qty
                            </Table.HeaderCell> */}
                            <Table.HeaderCell sorted={column === 'start_date' ? direction : null} onClick={this.handleSort('start_date')}>
                                Start Date
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'expiry_date' ? direction : null} onClick={this.handleSort('expiry_date')}>
                                Expiry Date
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Discount %
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cash Value
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Min Purchase
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                User Limit
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Max Usage Limit
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Actions
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {voucher_list[page] &&
                            (voucher_list.length > 0) ?
                            voucher_list[page].map((voucher) => {

                                let status_icon = '';
                                let status_color = '';
                                let status_text = '';

                                // compare start date and expiry date, and determined the voucher staus
                                // possible value
                                // * Haven't started
                                // * Ongoing
                                // * Expired

                                if ((new Date(voucher.start_date)).getTime() > now.getTime()) {
                                    // haven't started
                                    status_icon = 'calendar alternate outline';
                                    status_color = 'yellow';
                                    status_text = 'Voucher not yet active';
                                } else if (voucher.expiry_date) {
                                    if ((new Date(voucher.expiry_date)).getTime() < now.getTime()) {
                                        // expired
                                        status_icon = 'calendar times outline';
                                        status_color = 'red';
                                        status_text = 'Voucher expired';
                                    } else {
                                        // ongoing
                                        status_icon = 'calendar check outline';
                                        status_color = 'green';
                                        status_text = 'Voucher is active';
                                    }
                                } else if (voucher.max_usage <= voucher.claimants.length) {
                                    status_icon = 'calendar check outline';
                                    status_color = 'red';
                                    status_text = 'Voucher finished';
                                } else {
                                    // ongoing
                                    status_icon = 'calendar check outline';
                                    status_color = 'green';
                                    status_text = 'Voucher is active';
                                }

                                return (
                                    <Table.Row key={voucher._id} >
                                        <Table.Cell style={{ textAlign: 'center' }}>
                                            <Popup
                                                trigger={<Icon name={status_icon} color={status_color} size='large' />}
                                                content={status_text}
                                                style={{ opacity: '0.7' }}
                                                inverted
                                            />
                                        </Table.Cell>
                                        <Table.Cell>{voucher._id}</Table.Cell>
                                        <Table.Cell>{voucher.description}{voucher.promo_product &&
                                            ` (   ${voucher.promo_product ? voucher.promo_product.toUpperCase() + "," : ""}
                                                    ${voucher.promo_product_material ? voucher.promo_product_material.toUpperCase() + "," : ""}
                                                    ${voucher.offer_qty >= 0 ? voucher.offer_qty : ""} ) `
                                        }
                                        </Table.Cell>
                                        {/* <Table.Cell>{voucher.offer_qty >= 0 ? voucher.offer_qty : "-"}</Table.Cell> */}
                                        <Table.Cell>{moment(voucher.start_date).format('DD-MM-YYYY')}</Table.Cell>
                                        {
                                            (voucher.expiry_date === null) ? (
                                                <Table.Cell>No expiry</Table.Cell>
                                            ) : (
                                                    <Table.Cell>{moment(voucher.expiry_date).format('DD-MM-YYYY')}</Table.Cell>
                                                )
                                        }
                                        {
                                            (voucher.discount_percentage === 0) ? (
                                                <Table.Cell>-</Table.Cell>
                                            ) : (
                                                    <Table.Cell>{`${voucher.discount_percentage.toFixed(2)} %`}</Table.Cell>
                                                )
                                        }
                                        {
                                            (voucher.discount_value === 0) ? (
                                                <Table.Cell>-</Table.Cell>
                                            ) : (
                                                    <Table.Cell>{`RM ${voucher.discount_value.toFixed(2)}`}</Table.Cell>
                                                )
                                        }
                                        <Table.Cell>{`RM ${voucher.min_purchase ? voucher.min_purchase.toFixed(2) : "-"}`}</Table.Cell>
                                        {
                                            (voucher.user_limit === 0)
                                                ? (<Table.Cell>No limit</Table.Cell>)
                                                : (<Table.Cell>{voucher.user_limit}</Table.Cell>)
                                        }
                                        {
                                            (voucher.max_usage === null)
                                                ? (<Table.Cell>No limit</Table.Cell>)
                                                : (<Table.Cell>{voucher.claimants.length} / {voucher.max_usage}</Table.Cell>)
                                        }
                                        <Table.Cell>
                                            <Button onClick={this.deleteVoucher.bind(this, voucher._id)}>DELETE</Button>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            }) :
                            <Table.Row>
                                <Table.Cell colSpan="9" textAlign="center">
                                    No Record Found
                             </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ voucher, product }) => {
    return { voucher, product }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showLoading: showLoading,
        hideLoading: hideLoading,
        setActivePage: setActivePage,
        getVouchers: getVouchers,
        openVoucherModal: openVoucherModal,
        createVoucher: createVoucher,
        deleteVoucher: deleteVoucher,
        getProductMaterials: getProductMaterials,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Vouchers);
